import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    coverPsychologistLine,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

/** Tipográfica minimalista: título serifado no terço óptico, um filete, meta em duas colunas. */
export const Editorial: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => {
    const psychologist = coverPsychologistLine(fields);
    const hasLeftMeta = Boolean(fields.patient_name || fields.solicitante);
    const hasRightMeta = Boolean(psychologist || fields.city_date);

    return (
        <div className="flex size-full flex-col px-[3em] pb-[2.6em] pt-[3em]">
            <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
            <div className="mt-[7.4em]">
                {fields.subtitle ? (
                    <div
                        className="mb-[1.6em] uppercase tracking-[0.34em]"
                        style={{
                            fontSize: coverTitleSize(0.62),
                            color: COVER_DIM_ON_LIGHT,
                        }}
                    >
                        {fields.subtitle}
                    </div>
                ) : null}
                <div
                    className="font-bold leading-[1.02] tracking-[-0.02em]"
                    style={{
                        fontFamily: COVER_DISPLAY_FONT_VAR,
                        fontSize: coverTitleSize(3.1),
                        maxWidth: '7.5em',
                    }}
                >
                    {fields.document_title}
                </div>
                <div
                    className="mt-[1.5em] h-[2px] w-[2.6em]"
                    style={{ backgroundColor: colors.primary }}
                />
            </div>
            {hasLeftMeta || hasRightMeta ? (
                <div
                    className="mt-auto flex items-end justify-between text-[0.62em] leading-[1.75]"
                    style={{ color: COVER_DIM_ON_LIGHT }}
                >
                    <div>
                        {fields.patient_name ? (
                            <div className="text-[1.18em] font-semibold text-[#16181d]">
                                {fields.patient_name}
                            </div>
                        ) : null}
                        {fields.solicitante ? <div>{fields.solicitante}</div> : null}
                    </div>
                    <div className="text-right">
                        {psychologist ? <div>{psychologist}</div> : null}
                        {fields.city_date ? <div>{fields.city_date}</div> : null}
                    </div>
                </div>
            ) : null}
        </div>
    );
};
